<template>
<div class="con">
    <div class="title">
        <h2>신청결과</h2>
<!--        <p>신청이 완료되었습니다.</p>-->
    </div>
    <progress-bar></progress-bar>
    <div class="mt-50 apply-fieldset">
        <div v-html="completeContents">

        </div>
        <div class="apply-program-wrap mt-20">
            <div class="apply-select-number">
                신청한 클래스 <span class="txt-red">({{subjectLength}})</span>
                <!-- <button class="pointer" @click="moveSelectPage()">다시 선택하기</button> -->
            </div>
            <div class="apply-program-select">
                <ul v-if="sessionData.classList && sessionData.classList.length > 0">
                    <!-- 선택 했을 경우 -->
                    <div v-for="(classItem, idx) of sessionData.classList" :key="idx">
                        <li class="program-select blue" v-for="(item, index) of classItem.subjectList" :key="index">
                            <div class="apply-program-unit">
                                <ul>
                                    <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                                    <li class="unit-title blue" data-toggle="modal" data-target="#program-info">
                                        <h4 class="pay-title" @click="openModal('detail', item)">{{item.subjectName}}</h4>
                                    </li>
                                    <li>
                                        <p v-for="(item, index) of viewItemList(item)" :key="index">
                                            <span>{{item.key || '-'}} <b class="bold">{{item.value || '-'}}</b></span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </div>
                </ul>
            </div>
        </div>
        <!-- <table v-if="sessionData.classList && sessionData.classList.length > 0" class="hq-table-col mt-30"> -->
        <table v-if="finishData !== ''" class="hq-table-col mt-30">
            <thead>
                <tr>
                    <th class="txt-center">No</th>
                    <th class="txt-center">클래스명</th>
                    <th class="txt-center">신청일</th>
                    <th class="txt-center" v-if="payStatus !=='X'">결제금액</th>
                    <th class="txt-center" v-if="payStatus !=='X'">결제수단</th>
                    <th class="txt-center">결제여부</th>
                    <th class="txt-center">상태</th>
                    <!-- <th class="txt-center" v-if="cancle_YN !=='N'">수강취소</th> -->
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) of finishData" :key="index">
                    <td>{{finishDataLength - index}}</td>
                    <!-- <td class="pointer txt-blue break-all">{{item.subjectName}}</td> -->
                    <td class="break-all">{{item.subjectName || '없음'}}</td>
                    <td class="bold">{{item.updateDate.slice(0,10)}}</td>
                    <td v-if="payStatus !=='X'">{{numberFormat(item.price || '-')}} 원</td>
                    <td v-if="payStatus !=='X'">{{formatPayWay(item.payWay)}}</td>
                    <td>{{formatPayStatus(item.payStatus)}}</td>
                    <td :class="{'txt-red': item.status === 'Y'}">{{formatStatus(item.status)}}</td>
                    <!-- <td v-if="cancle_YN !=='N'">
                        <span class="pointer txt-blue" @click="openModal('cancel', item)" v-if="item.payStatus ==='Y'">
                            취소하기
                        </span>
                        <span class="pointer txt-blue" @click="cancelSugang(item)" v-else-if="item.payStatus === 'X'">
                            취소하기
                        </span>
                        <span v-else>-</span>
                    </td> -->
                </tr>
                <!-- <tr>
                    <td>3</td>
                    <td class="pointer txt-blue break-all">당근영어 1기</td>
                    <td class="bold">2020-00-00</td>
                    <td>50,000원</td>
                    <td>카드</td>
                    <td>결제완료</td>
                    <td>대기</td>
                    <td class="pointer txt-blue">취소하기</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td class="pointer txt-blue break-all">당근영어 1기</td>
                    <td class="bold">2020-00-00</td>
                    <td>30,000원</td>
                    <td>카드</td>
                    <td class="pointer txt-blue">결제취소</td>
                    <td>신청취소</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>1</td>
                    <td class="pointer txt-blue break-all">당근영어 1기</td>
                    <td class="bold">2020-00-00</td>
                    <td>30,000원</td>
                    <td>카드</td>
                    <td class="pointer txt-blue">결제취소</td>
                    <td>신청취소</td>
                    <td>-</td>
                </tr> -->
            </tbody>
        </table>
    </div>
    <div class="apply-agree-btn">
        <button type="button" :class="setButtonColor()" @click="goList()">신청내역 확인하기</button>
    </div>
    <cancel-modal v-if="isCancelModalOpened" :parentCancelData="parentCancelData" :parentIdx="parentIdx" @close="closeModal" @refresh="refreshModal"></cancel-modal>
    <detail-process v-if="isDetailModalOpened" :parentData="parentData" @close="closeModal()"></detail-process>
</div>
</template>

<script>
import DetailProcess from '@/components/reg/select/detailModal.vue'
import CancelModal from '@/components/applyList/cancel.vue'
export default {
    components: {
        DetailProcess,
        CancelModal
    },
    data: () => ({
        completeContents: '',
        sessionData: {}, // 세션 스토리지 수강신청 등록 전체 데이터
        subjectLength: 0, // 클래스 개수
        isDetailModalOpened: false, // 클래스 상세보기 레이어팝업 on/off
        isCancelModalOpened: false, // 수강취소 레이어팝업 on/off
        onPaymentPage: true,
        parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터
        parentIdx: '',
        parentCancelData: {},
        finishData: {},
        finishDataLength: 0,
        payStatus: '',
        cancle_YN: 'Y',

        pointColor: 'blue'
    }),

    mounted() {
        // 관리자단 컬러 설정한 색상 할당
        this.pointColor = sessionStorage.getItem('pointColor')

        // 수강신청 취소 기능 여부 (관리자단에서 설정시)
        this.cancle_YN = sessionStorage.getItem('cancle_YN')

        // 결제 페이지가 있는지 확인
        var pOrder = JSON.parse(sessionStorage.getItem('pOrder'))
        if (pOrder.includes('payment')) {
            this.onPaymentPage = true
        } else {
            this.onPaymentPage = false
        }

        this.loadSugangData()
        this.openCompletePopup()

        // TODO : 추후에 변경 필수 !!
        // var idx = sessionStorage.getItem('pageIdx')
        // mainIdx
        var idx = sessionStorage.getItem('mainIdx');
        var params = {
            idx: idx
        }
        this.axios.get(this.axios.root + this.axios.port + `/sugang/complete/${idx}`, {
            params: params
        }).then(res => {
            // console.log('res', res)
            if (res.data.err === 0) {
                this.completeContents = res.data.complete.complete_contents
            } else {
                // alert(res.data.result)
            }
        })
    },

    watch: {
        // 등록 페이지 내의 현재 라우터 경로 감지
        // Watch에 넣어놓은 이유는 keep-alive 사용으로 페이지 진입후 재진입할때 mount가 안되기 때문
        '$route'(to) {
            if (this.$route.fullPath === '/user/reg/complete') {
                this.loadSugangData()
                this.openCompletePopup()
            }
        }
    },

    methods: {
        openCompletePopup() {
            if (!sessionStorage.getItem('selectPopup')) {
                return
            }

            let routeData = this.$router.resolve({
                name: 'reg-select-popup',
                query: {
                    mainIdx: sessionStorage.getItem('mainIdx')
                }
            })

            window.open(
                routeData.href,
                'window팝업',
                'width=500, height=400, top:50, left:50, menubar=no, status=no, toolbar=no'
            )

            sessionStorage.removeItem('selectPopup')
        },

        setButtonColor() {
            if (this.pointColor === 'Blue') {
                return 'blue'
            } else if (this.pointColor === 'Red') {
                return 'red'
            } else if (this.pointColor === 'Green') {
                return 'green'
            }
        },

        cancelSugang(data) {
            var subjectIdx = data.idxItmSugangSubject
            var params = {
                cardName: '',
                subjectIdx: subjectIdx
            }

            var con_test = confirm("해당 수강신청을 정말 취소하시겠습니까?");
            if (con_test == true) {
                this.axios.post(this.axios.root + this.axios.port + `/user/cancle-apply/${subjectIdx}`, params)
                    .then(res => {
                        // console.log('res', res)
                        data.status = 'C'
                        sessionStorage.setItem('finishData', JSON.stringify(this.finishData))
                        alert('수강신청이 취소되었습니다')
                    })
            } else {
                return false
            }
        },

        // 결제방법에 따른 한글 변환
        formatPayWay(status) {
            switch (status) {
                case 'C':
                    return '카드'
                case 'A':
                    return '계좌이체'
                default:
                    return '-'
            }
        },

        // payStatus에 따른 한글 변환
        formatPayStatus(status) {
            switch (status) {
                case 'Y':
                    return '결제완료'
                case 'N':
                    return '미결제'
                case 'X':
                    return '결제없음'
                case 'C':
                    return '결제취소'
                case 'P':
                    return '결제취소대기'
                default:
                    return '-'
            }
        },

        // status에 따른 한글 변환
        formatStatus(status) {
            switch (status) {
                case 'Y':
                    return '대기자'
                case 'N':
                    return '신청완료'
                case 'C':
                    return '신청취소'
                case 'F':
                    return '신청실패'
                default:
                    return '-'
            }
        },

        // 세션 스토리지 수강신청 전체 데이터 loading
        loadSugangData() {
            if (sessionStorage.getItem("finishData")) {
                this.finishData = JSON.parse(sessionStorage.getItem("finishData"));
                this.finishDataLength = this.finishData.length
                this.payStatus = this.finishData[0].payStatus
            } else {
                this.finishData = ''
            }

            this.sessionData = JSON.parse(sessionStorage.getItem("classData"));
            this.info = this.sessionData.info
            this.totalPayment = this.sessionData.totalPayment

            var count = 0
            if (this.sessionData.classList) {
                for (var item of this.sessionData.classList) {
                    for (var subject of item.subjectList) {
                        count += 1
                    }
                }
            }

            this.subjectLength = count

            for (var item of this.info) {
                if (item.item_name === '이름') {
                    this.name = item.value
                    // console.log('item.value', item.value)
                } else if (item.item_name.includes('E-mail@')) {
                    // console.log('item.value', item.value)
                    this.email = item.value
                }
            }

            // 신청완료 된 후에는 클래스 데이터 초기화
            // sessionStorage.clear()
        },

        viewItemList(data) {
            if (data.columnOrder) {
                var itemList = data.columnOrder.split('^')
                var returnItemList = []
                for (var item of itemList) {
                    if (item === '언어') {
                        returnItemList.push({
                            key: item,
                            value: data.language
                        })
                    } else if (item === '장소') {
                        returnItemList.push({
                            key: item,
                            value: data.place
                        })
                    } else if (item === '요일') {
                        if (data.day && typeof data.day === 'string') {
                            returnItemList.push({
                                key: item,
                                value: data.day.replace(/\^/gi, "")
                            })
                        }
                    } else if (item === '교육시간') {
                        returnItemList.push({
                            key: item,
                            value: data.subjectStartTime + '~' + data.subjectEndTime
                        })
                    } else if (item === '교육비') {
                        if (this.onPaymentPage) {
                            returnItemList.push({
                                key: item,
                                value: data.eduPrice
                            })
                        }
                    } else if (item === '교재비') {
                        if (this.onPaymentPage) {
                            returnItemList.push({
                                key: item,
                                value: data.bookPrice
                            })
                        }
                    }
                }

                return returnItemList
            } else {
                return []
            }
            // console.log('data', data)
            return ['']
        },

        refreshModal() {
            this.isCancelModalOpened = false
            for (var item of this.finishData) {
                if (item.idxItmSugangSubject === this.parentIdx) {
                    item.status = 'C'
                    item.payStatus = 'P'
                }
            }

            sessionStorage.setItem('finishData', JSON.stringify(this.finishData))
        },

        // 신청내역 확인하기 페이지로 이동
        goList() {
            this.$router.push('/user/applyList')
        },

        // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
        numberFormat(inputNumber) {
            // console.log(inputNumber, inputNumber)
            return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        // 각 단계로 이동
        step(position) {
            this.$router.push(`/user/reg/${position}`)
        },

        // 클래스선택 페이지로 이동
        moveSelectPage() {
            this.$router.push('/user/reg/select')
        },

        // 클래스 상세보기 레이어팝업 열기
        openModal(type, data) {
            if (type === 'detail') {
                this.parentData = data
                this.isDetailModalOpened = true
            } else {
                this.isCancelModalOpened = true
                // console.log(data)
                this.parentCancelData = data
                this.parentIdx = data.idx
            }
        },

        // 모달 닫기
        closeModal() {
            if (this.isDetailModalOpened) {
                this.isDetailModalOpened = false
            } else {
                this.isCancelModalOpened = false
            }

        }
    }
}
</script>
